export const stage = "qa";

export const wsEndpoint = process.env.REACT_APP_WS_ENDPOINT
export const baseEndpoint = process.env.REACT_APP_REST_API_ENDPOINT

export const locationsEndpoint = `${baseEndpoint}/locations`;
export const locationGroupsEndpoint = `${baseEndpoint}/locationGroups`;
export const locationEndpoint = `${baseEndpoint}/locations/LOCATIONID`;
export const logEndpoint = `${baseEndpoint}/log`;

export const doorsPath = "/doors";
// door sensors are assigned to a floor, not to a door
export const doorSensorsPath = "/door-sensors";



